<script setup>
import Button from './button/Button.vue';
defineProps({
  title: {
    type: String,
    required: true,
  },
  buttons: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['click', 'close']);

const handleButtonClick = button => {
  emit('click', button.key);
};
</script>

<template>
  <div
    class="flex items-center justify-between px-4 h-14 border-b border-n-weak/50 dark:border-n-strong/15 bg-transparent backdrop-blur-md sticky top-0 z-20"
  >
    <div class="flex items-center justify-between gap-2 flex-1">
      <span class="font-bold text-sm tracking-tight text-foreground">{{
        title
      }}</span>
      <div class="flex items-center gap-1">
        <Button
          v-for="button in buttons"
          :key="button.key"
          v-tooltip="button.tooltip"
          :icon="button.icon"
          variant="ghost"
          size="sm"
          class="rounded-xl hover:bg-accent"
          @click="handleButtonClick(button)"
        />
        <Button
          v-tooltip="$t('GENERAL.CLOSE')"
          icon="i-lucide-x"
          variant="ghost"
          size="sm"
          class="rounded-xl hover:bg-destructive/10 hover:text-destructive"
          @click="emit('close')"
        />
      </div>
    </div>
  </div>
</template>
